import type { ModalFuncProps } from "antd"

import type { ProjectListItem } from "../types/types"

// i18next's own TFunction widens to TFunctionResult, which antd's title and
// button labels reject.
export type Translate = (key: string, vars?: Record<string, unknown>) => string

export const LEAD_IS_KEPT_KEY = "projectDelete.leadIsKept"

// Named rather than generic: two adjacent archived rows would otherwise open a
// byte-identical dialog (UI_UX_GUIDELINES §5.13).
export const deleteConfirmationContent = (
  t: Translate,
  { name, keepsLead }: { name?: string | null; keepsLead?: boolean }
) => {
  const opening = name
    ? t("projectDelete.confirm", { name })
    : t("projectDelete.confirmNoName")

  return keepsLead ? `${opening} ${t(LEAD_IS_KEPT_KEY)}` : opening
}

type ConfirmProjectDelete = {
  modal: { confirm: (config: ModalFuncProps) => unknown }
  t: Translate
  record: Pick<ProjectListItem, "id" | "lead_name" | "delete_keeps_lead">
  deleteProject: (id: string) => { unwrap: () => Promise<unknown> }
  onDeleted: () => void
}

export const confirmProjectDelete = ({
  modal,
  t,
  record,
  deleteProject,
  onDeleted
}: ConfirmProjectDelete) =>
  modal.confirm({
    centered: true,
    title: t("projectDelete.confirmTitle"),
    content: deleteConfirmationContent(t, {
      name: record.lead_name,
      keepsLead: record.delete_keeps_lead
    }),
    cancelText: t("projectDelete.cancel"),
    okText: t("projectDelete.delete"),
    okButtonProps: { danger: true, ghost: true },
    onOk: async () => {
      // antd closes the dialog only when onOk resolves, so a rejection would
      // leave it open over a live Delete button.
      try {
        await deleteProject(record.id).unwrap()
        onDeleted()
      } catch (e) {
        console.log(e)
      }
    }
  })
